import {
  Building2,
  CalendarCheck,
  CalendarDays,
  CreditCard,
  Headset,
  Instagram,
  Mail,
  Send,
  Sheet,
  Slack,
  Star,
  Webhook,
  Zap,
} from "lucide-react";
import {
  siGooglecalendar,
  siGooglesheets,
  siHubspot,
  siInstagram,
  siTelegram,
  siZapier,
} from "simple-icons";
import { marchio } from "./brand";

// Slack ha chiesto di togliere il suo logo da simple-icons: resta l’icona, sul
// suo colore ufficiale (aubergine). Per l’app vera: SVG dal kit di Slack.
const SLACK = { hex: "#4A154B", title: "Slack" };
// Instagram usa un gradiente, non un colore pieno.
const INSTAGRAM = marchio(siInstagram, {
  sfondo: "radial-gradient(circle at 30% 107%, #FDF497 0%, #FDF497 5%, #FD5949 45%, #D6249F 60%, #285AEB 90%)",
});

/**
 * Le app in arrivo: stanno nel catalogo con la pillola «In arrivo», come le
 * piattaforme non ancora pronte nella Panoramica. Non hanno impostazioni sul
 * server, non si aprono e non si attivano. Quando una diventa vera, esce da
 * qui e va in registry.js con la sua pagina.
 */
const inArrivo = (id, title, category, description, icon, tint, brand) => ({
  id,
  settingsKey: `in_arrivo_${id}`,
  title,
  category,
  description,
  tagline: description,
  icon,
  tint,
  brand,
  examples: [],
  inArrivo: true,
  ready: () => false,
});

export const APPS_IN_ARRIVO = [
  inArrivo("appuntamenti", "Prenota un appuntamento", "Appuntamenti", "L'assistente mostra gli orari liberi e fissa l'appuntamento sul vostro calendario.", CalendarDays, "blue"),
  inArrivo("operatore", "Passa a un operatore", "Assistenza", "Quando serve una persona, l'assistente passa la chat a qualcuno del team.", Headset, "violet"),
  inArrivo("slack", "Avvisi su Slack", "Notifiche", "Ogni nuovo contatto arriva nel canale del team, con il riassunto della chat.", Slack, "pink", SLACK),
  inArrivo("google-calendar", "Google Calendar", "Appuntamenti", "Gli appuntamenti presi in chat finiscono sul vostro Google Calendar.", CalendarCheck, "blue", marchio(siGooglecalendar)),
  inArrivo("telegram", "Telegram", "Canali", "L'assistente risponde anche su Telegram, con le stesse fonti del sito.", Send, "sky", marchio(siTelegram)),
  inArrivo("instagram", "Instagram e Messenger", "Canali", "L'assistente risponde ai messaggi diretti delle vostre pagine.", Instagram, "pink", INSTAGRAM),
  inArrivo("hubspot", "HubSpot CRM", "CRM", "I contatti raccolti entrano in HubSpot con il riassunto della chat.", Building2, "orange", marchio(siHubspot)),
  inArrivo("sheets", "Google Sheets", "Dati", "Ogni contatto raccolto diventa una riga del vostro foglio.", Sheet, "green", marchio(siGooglesheets)),
  inArrivo("pagamenti", "Link di pagamento", "Pagamenti", "L'assistente manda un link per pagare un acconto o un servizio.", CreditCard, "violet"),
  inArrivo("zapier", "Zapier e Make", "Automazioni", "Collega l'assistente a migliaia di app senza scrivere codice.", Zap, "orange", marchio(siZapier)),
  inArrivo("newsletter", "Newsletter", "Marketing", "Chi lo chiede viene iscritto alla vostra lista, con il suo consenso.", Mail, "amber"),
  inArrivo("webhook", "Webhook", "Sviluppatori", "I contatti raccolti partono verso il vostro gestionale.", Webhook, "sky"),
  inArrivo("gradimento", "Voto a fine chat", "Feedback", "A fine conversazione l'assistente chiede un voto da 1 a 5.", Star, "amber"),
];
